import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";

// Utilities
import { getVendorViaLink } from "../../Request/VendorRequests";
import { saveNewVendor } from "../../Redux/Actions/vendorActions";
import { isEmpty, match, round } from "../../Others/functions";
import { saveBillDetails } from "../../Redux/Actions/userActions";
import "./index.css";
import TitleBar from "./Components/CheckOrderPage/TitleBar";
import SavingsBanner from "./Components/CheckOrderPage/SavingsBanner";
import LastMinAddOn from "./Components/CheckOrderPage/LastMinAddOn";
import BillSummery from "./Components/CheckOrderPage/BillSummery";
import EmptyCart from "../../Store/Cart/Components/EmptyCart";
import Loading from "../../Others/Loading";
import Error from "../../Others/Error";
import OrderReview from "./Components/CheckOrderPage/OrderReview";

import useAddtoCart from "../../Redux/use-addtocart";
import { useQuery } from "react-query";
const url = process.env.React_App_Api_url;

const getProducts = async () => {
  try {
    const response = await fetch(`${url}/ruppeedeal`);
    if (!response.ok) {
      throw new Error("RUPPEE REQUEST RESPONSE FAILED");
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.log("ERROR AT GETTING RUPPEE ONE PRODUCTS", error);
  }
};

const Cart = () => {
  const store = "Rashan-4";
  const navigate = useNavigate();
  const [login, setLogin] = useState(false);
  const [err, setErr] = useState(false);
  const [initialValue, setInitialValue] = useState(800);
  const [dealValue, setDealValue] = useState(0);

  const {
    data: ruppeeData,
    isLoading: ruppeeLoading,
    isError: rupeeeError,
  } = useQuery(["RUPPEE_ONE_DATA"], () => getProducts());

  const { addItem, removeItem } = useAddtoCart();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const vendorId = "37cfbaa0cdd335e81abd4aba05c5e254";
  const delivery = useSelector(
    (state) =>
      state.vendor.vendorList?.filter((el) =>
        match(el.info?.storeLink, store)
      )?.[0]?.deliveryArea
  );
  const info = useSelector(
    (state) =>
      state.vendor.vendorList?.filter((el) =>
        match(el.info?.storeLink, store)
      )?.[0]?.info
  );
  const products = useSelector(
    (state) =>
      state.vendor.vendorList?.filter((el) =>
        match(el.info?.storeLink, store)
      )?.[0]?.products
  );
  const cart = useSelector(
    (state) =>
      state.user.cart?.filter((c) => c.vendorId === vendorId)?.[0]?.cart
  );
  const user = useSelector((state) => state.user.info);
  const address = useSelector((state) => state.user.address);

  const [bill, setBill] = useState(null);
  const [rupeeOneBill, setRuppeeOneBill] = useState(null);
  const [allowedAddress, setAllowed] = useState([]);
  const [selected, setSelected] = useState(null);
  const [editable, setEditable] = useState({});

  useEffect(() => {
    let tempSel;
    let filtered = delivery?.filter((el) => el.pincode);
    if (filtered?.length) {
      let pins = filtered?.map((el) => el.pincode) || [];
      let allowed =
        address?.filter(
          (el) => pins.includes(el.pincode) && el?.address !== ""
        ) || [];
      setAllowed(allowed);
      tempSel = allowed.filter((el) => el.primary === "true")?.[0];
    } else {
      let allowed = address?.filter((el) => el?.address !== "") || [];
      setAllowed(allowed);
      tempSel = address?.filter((el) => el.primary === "true")?.[0];
    }

    // If selected is already set
    if (selected) {
      setSelected(address?.find((el) => el.addressId === selected?.addressId));
    } else {
      setSelected(tempSel);
    }
  }, [delivery, address, selected]);

  useEffect(() => {
    if (cart?.length) {
      const filteredCartForRupperOneDeals = cart.filter((item) =>
        item.subCat === "Atta, Maida & Sooji" ||
        item.subCat === "Oil" ||
        item.subCat === "Ghee & Vanaspati"
          ? false
          : true
      );
      if (filteredCartForRupperOneDeals?.length) {
        let ruppeeTemp = filteredCartForRupperOneDeals.reduce((t, product) => {
          let total = t.Total || 0;
          total += product.finalSp * product.qty;

          t = {
            Total: round(total, 2),
          };
          return t;
        }, {});

        if (state && state?.coupon.billAmount <= ruppeeTemp.Total) {
          let coupon = state.coupon;
          let discount;
          if (coupon.discountType === "Flat Discount") {
            discount = coupon.amount;
          } else {
            discount = round((ruppeeTemp?.Total * coupon.percent) / 100, 2);
            if (
              coupon.maxDiscount &&
              parseFloat(discount) > parseFloat(coupon.maxDiscount)
            ) {
              discount = coupon.maxDiscount;
            }
          }
          ruppeeTemp.Total = round(ruppeeTemp.Total - discount, 2);
        }

        setRuppeeOneBill(ruppeeTemp);
      }

      let temp = cart.reduce((t, product) => {
        let MRP = t.MRP || 0;
        let productDiscount = t?.["Product discount"] || 0;
        let slabDiscount = t?.["Slab discount"] || 0;
        let freeProduct = t?.["Free item discount"] || 0;
        let total = t.Total || 0;

        MRP += product.mrp * product.qty;
        productDiscount += (product.mrp - product.sp) * product.qty;
        slabDiscount += (product.sp - product.finalSp) * product.qty;
        freeProduct += product.free * product.mrp;
        total += product.finalSp * product.qty;

        t = {
          MRP: round(MRP, 2),
          "Product discount": round(productDiscount, 2),
          "Slab discount": round(slabDiscount, 2),
          "Free item discount": round(freeProduct, 2),
          Total: round(total, 2),
          "Coupon discount": 0,
        };
        return t;
      }, {});

      if (state && state?.coupon.billAmount <= temp.Total) {
        let coupon = state.coupon;
        let discount;
        if (coupon.discountType === "Flat Discount") {
          discount = coupon.amount;
        } else {
          discount = round((temp?.Total * coupon.percent) / 100, 2);
          if (
            coupon.maxDiscount &&
            parseFloat(discount) > parseFloat(coupon.maxDiscount)
          ) {
            discount = coupon.maxDiscount;
          }
        }
        temp.Total = round(temp.Total - discount, 2);
        temp["Coupon discount"] = discount;
      }

      let offer = false;

      if (
        info?.cartOfferFlag3 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue3)
      )
        offer = info.cartOffer3;
      else if (
        info?.cartOfferFlag2 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue2)
      )
        offer = info.cartOffer2;
      else if (
        info?.cartOfferFlag1 === 1 &&
        temp?.Total >= parseFloat(info?.cartValue1)
      )
        offer = info?.cartOffer1;

      if (offer) {
        let discount = round((temp?.Total * offer) / 100, 2);
        temp["cart discount"] = {
          pcnt: offer,
          str: `${offer}% cart discount`,
          amt: discount,
        };
        temp["Grand Total"] = round(temp.Total - discount, 2);
      }

      temp.saved = Object.keys(temp).reduce(
        (sum, type) =>
          type.includes("discount")
            ? type === "cart discount"
              ? (sum += temp[type].amt)
              : (sum += temp[type])
            : sum,
        0
      );

      setBill(temp);
      localStorage.setItem("BILL", JSON.stringify(temp));
      dispatch(saveBillDetails(temp));
    }
  }, [cart, info, state]);

  useEffect(() => {
    setLogin(!isEmpty(user));
  }, [user]);

  useEffect(() => {
    setLogin(!isEmpty(user));
  }, [user]);

  useEffect(() => {
    if (!rupeeOneBill) {
      return;
    }
    const ratio = rupeeOneBill?.Total / 800;
    let val = Math.trunc(ratio) + 1;
    if (Math.trunc(ratio) <= 7) {
      setDealValue(Math.trunc(ratio));
    }
    setInitialValue(val * 800);
  }, [rupeeOneBill]);

  useEffect(() => {
    //guard-clause
    if (ruppeeLoading || rupeeeError || !ruppeeData?.length || !cart?.length) {
      return;
    }
    ruppeeData.forEach((ruppeeItem) => {
      const index = cart.findIndex((cartItem) => {
        if (cartItem.pID === ruppeeItem.pID) {
          return true;
        }
      });
      //1-remove any ruppeeOne item from cart which is above deal value
      if (index !== -1 && ruppeeItem?.Priority > dealValue) {
        removeItem(cart[index]);
      }
      //2-if a item within dealvalue exists , skip it
      //3- if a item within dealvalue doesn't exit in cart, add it
      if (index === -1 && ruppeeItem?.Priority <= dealValue) {
        addItem(ruppeeItem);
      }
    });
  }, [dealValue, ruppeeLoading, cart]);

  {
    /* ---------------------JSX RETURN-------------------- */
  }
  return err ? (
    <Error err={err} />
  ) : vendorId ? (
    <>
      {cart?.length && !ruppeeLoading && !rupeeeError && ruppeeData?.length ? (
        <div className="cartPage">
          {/* ---------------------Title Bar--------------------- */}
          <TitleBar />
          {/* ----------------------Savings Banner--------------------- */}
          <SavingsBanner saved={bill?.saved} />
          {/* ----------------------add more item catalogue--------------------- */}
          <LastMinAddOn />
          {/* ----------------------Order Review--------------------- */}
          <OrderReview cart={cart} ruppeeData={ruppeeData} />
          {/* ----------------------Bill Summery--------------------- */}
          <BillSummery bill={bill} />
        </div>
      ) : (
        <EmptyCart />
      )}
    </>
  ) : (
    <Loading text="Getting your cart" />
  );
};

export default Cart;
